import type { DefaultOptionType } from 'antd/lib/select';
import { localeSort } from './string/locale-sort';

export const mapListToIdSelectOptions = (list: { name?: string | null; id: string | number }[]): DefaultOptionType[] =>
  list
    ?.map(item => ({
      label: item.name,
      value: item.id,
    }))
    .sort(({ label: labelA }, { label: labelB }) => localeSort(labelA, labelB));
